module.exports = __webpack_public_path__ + "static/media/Claire-8.1b574811.png";